import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core/';
import React, { useState } from 'react';
import { ReferenceArrayInput, required, TextInput } from 'react-admin';
import RoleApi from '../../core/apis/RoleApi';
import TreeInput from '../../core/components/inputs/TreeInput';
import { authoritiesToExclude } from './RoleLookups';
import { isStringAlphaNumeric } from '../../core/utils/index';

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  },
  formCheckBox: {
    marginTop: '19px'
  },
  gridItem: {
    paddingBottom: '0px !important'
  }
});

const RoleSummary = props => {
  const [formErrors, setFormErrors] = useState({});
  const classes = useStyles();

  const validateRoleName = async (value, allValues, props) => {
    if (props.active) {
      let error;
      const nameBlank = value.trim().length === 0;

      if (nameBlank) {
        error = `Role Name can't be empty space(s)`;
      } else if (props.initial === value) {
        error = undefined;
      } else {
        const nameExists = await RoleApi.checkNameExists(value);
        if (nameExists) {
          error = 'Role name already exists';
        } else {
          error = undefined;
        }
      }
      setFormErrors({ ...formErrors, name: error });
      return error;
    }
    return formErrors.name;
  };
  /*
   * Verify that Role ID is unique
   */
  const validateRoleId = async (value, allValues, props) => {
    if (props.active) {
      const idValid = value.startsWith('ROLE_');
      const splittedId = value.split('ROLE_');
      let error;

      if (value.includes(' ')) {
        error = `Role ID can't contain any empty space`;
      } else if (!idValid) {
        error = 'Role ID needs to start with ROLE_';
      } else if (splittedId[1] === '') {
        error = 'Role ID cannot be null after ROLE_';
      } else if (!isStringAlphaNumeric(splittedId[1])) {
        error = 'Role ID cannot contains special characters after ROLE_';
      } else {
        const idExists = await RoleApi.checkIdExists(value);
        if (idExists) {
          error = 'Role ID already exists';
        } else {
          error = undefined;
        }
      }
      setFormErrors({ ...formErrors, id: error });
      return error;
    }
    return formErrors.id;
  };

  const filter = choices => {
    return choices.filter(item => !authoritiesToExclude.includes(item.id));
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Details</Typography>
        </Grid>
        <Grid item xs={8} className={classes.gridItem}>
          <TextInput
            source="description"
            label="Access Role Name"
            validate={[required(), validateRoleName]}
            options={{ autoComplete: 'off' }}
            variant={props.variant}
            helperText={false}
          />
        </Grid>
        <Grid item xs={4} className={classes.gridItem}>
          <TextInput
            source="id"
            label="Access Role ID"
            validate={[required(), validateRoleId]}
            options={{ autoComplete: 'off' }}
            variant={props.variant}
            disabled={!props.creation}
            helperText={false}
          />
        </Grid>
        <ReferenceArrayInput
          label=" "
          resource="authorities"
          reference="authorities"
          source="authorities"
          perPage={-1}
          sort={{ field: 'id', order: 'ASC' }}
        >
          <TreeInput
            optionText="description"
            optionTextLabel="Description"
            hasFilters
            filterFunction={filter}
            groupProp="group"
          />
        </ReferenceArrayInput>
      </Grid>
    </div>
  );
};

export default RoleSummary;
